import createVueComponent from '../createVueComponent';

const ArrowDownRight = createVueComponent('ArrowDownRightIcon', [
  ['path', { d: 'm7 7 10 10', key: '1fmybs' }],
  ['path', { d: 'M17 7v10H7', key: '6fjiku' }],
]);

export default ArrowDownRight;
